import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";

export const RegistrarsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListRegistrars') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateRegistrar') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/registrars'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetRegistrar') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/registrars'/>
                    )
                }
            />
        </Routes>
    );
};
